import { Grid } from '@mui/material'
import styles from './authCommonCard.module.scss'
const AuthCommonCard = ({ className, children }) => {
	return (
		<section className={`${styles.authCommonSection} ${className}`}>
			<div className="container">
				<div className={styles.inner}>
					<Grid container alignItems={'unset'}>
						<Grid size={{ xs: 12, sm: 6 }}>
							<div className={styles.imageContainer}>
								<img
									src="/images/signup-img.png"
									alt="signup-img.jpg"
								/>
							</div>
						</Grid>
						{/* right side content */}
						{children}
					</Grid>
					<div className={`${styles.bgImg} ${className}`}>
						<img src="/images/clock-img.png" alt="clock-img.png" />
					</div>
				</div>
			</div>
		</section>
	)
}

export default AuthCommonCard
